export default "__VITE_ASSET__DzjNOzsk__"